import { useQuery, UseQueryOptions, UseQueryResult } from '@tanstack/react-query';

import servicePeople from 'services/people';

/**
 * @typedef {Object} PaymentEmailBranding
 * @property {string|null} logo - Account logo URL
 * @property {string|null} primary_color - Primary brand color (hex)
 */

/**
 * @typedef {Object} PaymentEmailVerifyResponse
 * @property {string} first_name - Person's first name (may be empty string)
 * @property {string} payment_email - Current payment email on file
 * @property {PaymentEmailBranding|null} branding - Account branding (logo, primary color)
 */

/** @typedef {Omit<UseQueryOptions<PaymentEmailVerifyResponse, Error>, 'queryKey' | 'queryFn'>} UsePaymentEmailVerifyQueryOptions */

/**
 * Verifies a payment-email-change token and returns the person's current data.
 * Intended for the self-service payment email change page.
 *
 * The query is disabled when `token` is falsy, so the caller should
 * pass `enabled: !!token` or rely on the default `enabled` derived from the token.
 *
 * @param {string} token - Encrypted payment email change token from the URL
 * @param {UsePaymentEmailVerifyQueryOptions} [options={}]
 * @returns {UseQueryResult<PaymentEmailVerifyResponse, Error>}
 */
export const usePaymentEmailVerifyQuery = (token, options = {}) =>
    useQuery({
        queryKey: ['payment-email-verify', token],
        queryFn: () => servicePeople.verifyPaymentEmailToken(token),
        retry: false,
        staleTime: Infinity,
        ...options
    });
